const loadingLabel = "Cargando";
const esUS = {
  loadingLabel
};
export {
  esUS as default,
  loadingLabel
};
